import PropTypes from "prop-types";
import s from "./Contracts.module.css";

const Contracts = ({ addresses }) => {
    const gumballUrl = `${addresses.explorerBase}address/${addresses.gumball}`;
    const animaUrl = `${addresses.explorerBase}address/${addresses.anima}`;

    return (
        <div className={s.contracts}>
            <ul>
                <li>
                    Gacha:{" "}
                    <a href={gumballUrl} target="_blank" rel="noreferrer">
                        {addresses.gumball}
                    </a>
                </li>
                <li>
                    Anima:{" "}
                    <a href={animaUrl} target="_blank" rel="noreferrer">
                        {addresses.anima}
                    </a>
                </li>
            </ul>
        </div>
    );
};

Contracts.propTypes = {
    addresses: PropTypes.object,
};

export { Contracts };
